import type { FC } from 'react';

import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';

interface ChatControlPlainProps {
  onClick: () => void;
  condition: boolean;
  isPrivateTable: boolean;
  badge?: number;
}

export const ChatControlPlain: FC<ChatControlPlainProps> = ({ condition, onClick, isPrivateTable, badge }) => {
  return (
    <IconButtonWithTooltip
      data-testid="chat-button"
      icon={isPrivateTable ? Icons.PriveChat : Icons.Chat}
      active={condition}
      badge={Boolean(isPrivateTable && badge)}
      onClick={onClick}
      tooltipOptions={{
        text: condition ? 'CHATOFF' : 'CHATON',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
